import PageTitle from "componets/molecules/PageTitle/pageTitle";
import DescriptionRows from "componets/organisms/descriptionRows/descriptionRows";
import MenuInOrbit from "componets/organisms/menuInOrbit/menuInOrbit";
import UgraduateContent from "componets/organisms/ugraduateContent/ugraduateContent";
import React, { useEffect, useState } from "react";
import { Route, Routes, useNavigate, useParams } from "react-router-dom";
import imgSrc from "titleImages/calendar.JPG";
import "./unGraduateTemplate.scss";
const UnGraduateTemplate = ({ dataRow, currentOption }) => {
  //const {type}=useParams()
  const type = currentOption;

  const navigate = useNavigate();

  const programSelected = dataRow.find((element) => element.id == type);
  const [currentURL, setCurrentURL] = useState(useParams()["*"]);
  const [currentData, setCurrentData] = useState("");
  const [displayedContent, setDisplayedContent] = React.useState("perfil");
  const breadcrumsData = [
    { text: "Inicio", link: "/" },
    { text: "Programas", link: "/programas" },
    {
      text:
        programSelected.title.charAt(0).toUpperCase() +
        programSelected.title
          .substring(1, programSelected.title.legth)
          .toLowerCase(),
      link: `/programa/${programSelected.id}/perfil`,
    },
  ];

  useEffect(() => {
    const comparableValue =
      displayedContent === "" ? currentURL : displayedContent;
    var proveExistence =
      comparableValue == "perfil" ||
      comparableValue == "objetivos" ||
      comparableValue == "planEstudios";
    if (proveExistence) setCurrentData(comparableValue);
  }, [displayedContent]);

  useEffect(() => {
    var result = menuOptions.categories[0].options.find((val) => {
      return val.value === currentURL;
    });
    if (result !== undefined) {
      setDisplayedContent(currentURL);
    } else {
      navigate(`/programas`);
    }
  }, [currentURL]);

  const menuOptions = {
    categories: [
      {
        categoryName: "Menu",
        options: [
          { name: "Perfil", value: "perfil" },
          { name: "Objetivo (s)", value: "objetivos" },
          { name: "Plan de estudios", value: "planEstudios" },
          { name: "Malla curricular", value: "/", isLink: true },
          { name: "Normatividad", value: "/", isLink: true },
        ],
      },
    ],
    aditionalButtons: [
      { name: "Admisiones", link: "https://admisiones.unal.edu.co/" },
    ],
  };

  //const objetives = programSelected.sections[1].descripcion

  const objetives = [];

  programSelected.objetives.descripcion.map((value) => {
    objetives.push(value.seccion);
  });

  const tablesInformation = [];

  programSelected.tables.map((value) => {
    const rows = [];

    value.filas.map((row) => {
      rows.push({
        title: row.title,
        COb: row.obligatorios,
        COp: row.optativos,
        CTo: row.totalExigidos,
      });
    });
    tablesInformation.push({
      sectionTitle: value.title,
      rows,
    });
  });

  const dataMenu = {
    title: {},
    perfil: {
      title: programSelected.profile.titulo,
      description: programSelected.profile.descripcion,
    },
    objetivos: {
      title: programSelected.objetives.titulo,
      description: objetives,
    },
    planEstudios: tablesInformation,
  };

  useEffect(() => {
    var result = dataRow.find((val) => val.id == type);
    if (result == undefined) {
      navigate(`/programas`);
    }
  }, []);

  return (
    <>
      <div>
        {!dataRow ? (
          <p>Un momento, mientras la información se carga</p>
        ) : (
          <>
            {programSelected !== undefined && (
              <>
                <div className="un-graduate-template__main-container">
                  <PageTitle
                    breadData={breadcrumsData}
                    type="left"
                    imgSrc={imgSrc}
                    data={{
                      title: programSelected.title,
                      description: programSelected.description,
                    }}
                  />
                  <DescriptionRows dataDescription={programSelected} />

                  <Routes>
                    <Route
                      path=":type"
                      element={
                        <div className={"un-graduate-template__content"}>
                          <MenuInOrbit
                            selectedOption={displayedContent}
                            setOption={setDisplayedContent}
                            type={2}
                            options={menuOptions}
                          />
                          {displayedContent === "perfil" && (
                            <UgraduateContent
                              data={dataMenu.perfil}
                              type={displayedContent}
                            />
                          )}
                          {displayedContent === "objetivos" && (
                            <UgraduateContent
                              data={dataMenu.objetivos}
                              type={displayedContent}
                            />
                          )}
                          {displayedContent === "planEstudios" && (
                            <UgraduateContent
                              data={dataMenu.planEstudios}
                              type={displayedContent}
                            />
                          )}
                        </div>
                      }
                    />
                  </Routes>
                </div>
              </>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default UnGraduateTemplate;
